// noinspection DuplicatedCode

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../../../assets/Colors";
import { maxPageGlobal } from "../../../../assets/config";
import { HrdInputGenerator } from "../../../../components/form/HrdInputGenerator";
import { isRequired, useForm } from "../../../../components/isRequired";
import { fetchPost, fetchPostSilance } from "../../../../fetchers";
import CutiApprovalActors from "./CutiApprovalActors";
import { getMinCuti } from "../../../master/cuti/masterCutiSlice";
import { karyawanSelector } from "../../karyawan/karyawanSlice";
import {
  cutiTransaksiSelector,
  kirimCutiTransaksi,
  updateCutiTransaksi,
} from "./cutiTransaksiSlice";
import { tanggalLokal } from "./tanggalLokal";
import FilterTahunRiwayat, { pesanKosong, saringTahun, tahunIni } from "./FilterTahunRiwayat";

const CutiPage = ({}) => {
  const navigate = useNavigate();
  let initialState = {
    Nik: "",
    JenisCuti: -1,
    KeperluanCuti: "",
    SisahCuti: "",
    Pengganti: "",
    Tiket: false,
    TanggalMulai: new Date(),
    TanggalAkhir: new Date(),
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ JenisCuti }) =>
      isRequired(JenisCuti) || { JenisCuti: "Jenis cuti wajib diisi" },
    ({ KeperluanCuti }) =>
      isRequired(KeperluanCuti) || {
        KeperluanCuti: "Keperluan cuti wajib diisi",
      },
    ({ Pengganti }) =>
      isRequired(Pengganti) || { Pengganti: "Pengganti wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
    changeHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(maxPageGlobal);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [param, setParam] = useState({ start: 0, count: maxPageGlobal, search: "" });

  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  // detail modal state
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [selectedKaryawan, setSelectedKaryawan] = useState(null);
  const [tahunRiwayat, setTahunRiwayat] = useState(tahunIni());

  const cuti = useSelector(cutiTransaksiSelector);
  const karyawan = useSelector(karyawanSelector);
  const [jumlahHari, setJumlahHari] = useState(0);
  // Sisa hak cuti PERIODE tanggal mulai: kontrak PKWT yang mencakupnya, selain itu tahun kalender.
  const [saldoTahun, setSaldoTahun] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const mutationGrouped = useMutation((param) => fetchPostSilance("getCutiGrouped", param));
  const mutationDetail = useMutation((param) => fetchPostSilance("getCutiByNik", param));
  const mutationInput = useMutation((param) => fetchPostSilance("insertCuti", param));
  const mutationHari = useMutation((param) => fetchPostSilance("calculateCuti", param));

  const handleInputSaldoCuti = () => {
    navigate("/human-resource/transaksi/input-saldo-cuti");
  };

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      const initValues = {
        TCutiID: currentData.TCutiID,
        Nik: currentData.Nik,
        JenisCuti: currentData.JenisCuti,
        KeperluanCuti: currentData.KeperluanCuti,
        Pengganti: currentData.Pengganti,
        SisahCuti: currentData.SisahCuti,
        Tiket: currentData.Tiket,
        TanggalMulai: new Date(currentData.TanggalMulai),
        TanggalAkhir: new Date(currentData.TanggalAkhir),
      };
      editHandler(initValues);
    }
  });

  useEffect(() => {
    loadGrouped();
  }, [param]);

  function loadGrouped() {
    let formData = new FormData();
    formData.append("start", param.start.toString());
    formData.append("count", param.count.toString());
    formData.append("search", param.search.toString());
    mutationGrouped.mutate(formData, {
      onSuccess: (data) => {
        const total = data?.count || 0;
        let calc = total - 1;
        if (calc <= 0) calc = 1;
        if (calc % count === 0) calc = calc + 1;
        setMaxPage(data?.data ? Math.ceil(calc / count) : 1);
      },
    });
  }

  function openDetail(row) {
    setSelectedKaryawan(row);
    setTahunRiwayat(tahunIni());
    let formData = new FormData();
    formData.append("Nik", row.Nik);
    mutationDetail.mutate(formData);
    setShowModalDetail(true);
  }

  useEffect(() => {
    if (
      values.Nik &&
      values.TanggalMulai &&
      values.TanggalAkhir &&
      values.JenisCuti !== -1
    ) {
      const formData = {
        TanggalMulai: tanggalLokal(values.TanggalMulai),
        TanggalAkhir: tanggalLokal(values.TanggalAkhir),
        CutiID: values.JenisCuti.toString(),
        Nik: values.Nik,
        TCutiID: showModalEdit ? values.TCutiID || "" : "",
      };
      const ids = karyawan.minDataCuti.find((x) => x.value === values.Nik);
      mutationHari.mutate(formData, {
        onSuccess: (data) => {
          const range = parseInt(data.data.Result);
          const saldo = data.data.Saldo ?? parseInt(ids?.SisahCuti || 0);
          setJumlahHari(range);
          setSaldoTahun(data.data.Saldo != null ? {
              tahun: data.data.Tahun, saldo: data.data.Saldo, periode: data.data.Periode,
              peringatan: data.data.Peringatan, blokir: data.data.Blokir,
            } : null);
          setButtonDisabled(saldo < range || !!data.data.Blokir);
        },
      });
    }
  }, [values]);

  useEffect(() => {
    setSaldoTahun(null);
    if (karyawan.minDataCuti) {
      const idss = karyawan.minDataCuti.find((x) => x.value === values.Nik);
      if (idss) {
        dispatch(getMinCuti({ GolonganID: idss.GolonganID, TipeKaryawanID: idss.TipeKaryawanID }));
      }
    }
  }, [values.Nik]);

  function handleSearch(e) {
    const val = e.target.value;
    setSearch(val);
    setParam({ start: 0, count: maxPageGlobal, search: val });
  }

  function handlePage(newPage) {
    setPage(newPage);
    setParam({ start: newPage * count - count, count, search });
  }

  const inputBuilder = [
    { type: "karyawanFull", name: "", title: "", handler: customHandler, modifiers: true, size: "full", required: false },
    { type: "cuti", name: "JenisCuti", title: "Jenis Cuti", handler: customHandler, modifiers: "", size: "full", required: true },
    { type: "text", name: "KeperluanCuti", title: "Keperluan Cuti", handler: changeHandler, modifiers: "", size: "full", required: true },
    { type: "karyawan", name: "Pengganti", title: "Pengganti", handler: customHandler, modifiers: "", size: "full", required: true },
    { type: "dateOnly", name: "TanggalMulai", title: "Tanggal Mulai", handler: customHandler, modifiers: "", size: "full", required: true },
    { type: "dateEnd", name: "TanggalAkhir", title: "Tanggal Akhir", handler: customHandler, modifiers: "", size: "full", required: true },
    { type: "yesNot", name: "Tiket", title: "Tiket", handler: customHandler, modifiers: "", size: "full", required: true },
  ];

  const rows = mutationGrouped.data?.data || [];
  const riwayatSemua = mutationDetail.data?.data || [];
  const riwayatTampil = saringTahun(riwayatSemua, tahunRiwayat);

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full" />
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                {/* Header */}
                <div className="flex flex-wrap items-center justify-between px-6 py-4 border-b gap-2">
                  <h2 className="text-lg font-semibold text-gray-700">Transaksi Cuti</h2>
                  <div className="flex items-center gap-2 flex-wrap">
                    <input
                      type="text"
                      placeholder="Cari nama karyawan..."
                      value={search}
                      onChange={handleSearch}
                      className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:border-blue-400"
                    />
                    <Button
                      color="lightBlue"
                      buttonType="solid"
                      size="sm"
                      onClick={handleInputSaldoCuti}
                    >
                      <i className="material-icons mr-1" style={{ fontSize: 16 }}>account_balance_wallet</i>
                      Input Saldo Cuti
                    </Button>
                    <Button
                      color="green"
                      buttonType="solid"
                      size="sm"
                      onClick={() => { clearHandler(); setShowModalAdd(true); setShowModalEdit(false); }}
                    >
                      <i className="material-icons mr-1" style={{ fontSize: 16 }}>add</i>
                      Tambah Data
                    </Button>
                  </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-left">
                    <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                      <tr>
                        <th className="px-4 py-3">No</th>
                        <th className="px-4 py-3">Nama Karyawan</th>
                        <th className="px-4 py-3 text-center">Saldo Hak Cuti</th>
                        <th className="px-4 py-3 text-center">Jumlah Cuti Diambil</th>
                        <th className="px-4 py-3 text-center">Saldo Akhir Cuti</th>
                        <th className="px-4 py-3 text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {mutationGrouped.isLoading ? (
                        <tr>
                          <td colSpan={6} className="px-4 py-8 text-center text-gray-400">
                            Loading...
                          </td>
                        </tr>
                      ) : rows.length === 0 ? (
                        <tr>
                          <td colSpan={6} className="px-4 py-8 text-center text-gray-400">
                            Tidak ada data
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, idx) => (
                          <tr key={row.Nik} className="hover:bg-gray-50">
                            <td className="px-4 py-3 text-gray-500">{param.start + idx + 1}</td>
                            <td className="px-4 py-3 font-medium text-gray-800">
                              {row.NamaKaryawan}
                              {row.Periode && <div className="text-xs font-normal text-gray-400">{row.Periode}</div>}
                            </td>
                            <td className="px-4 py-3 text-center">{row.HakCuti}</td>
                            <td className="px-4 py-3 text-center">{row.JmlCutiDiambil}</td>
                            <td className="px-4 py-3 text-center">
                              <span className={parseInt(row.SaldoAkhirCuti) <= 3 ? "text-red-600 font-semibold" : "text-green-600 font-semibold"}>
                                {row.SaldoAkhirCuti}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-center">
                              <button
                                onClick={() => openDetail(row)}
                                className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded"
                              >
                                Detail
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {maxPage > 1 && (
                  <div className="flex items-center justify-end gap-2 px-6 py-3 border-t">
                    <button
                      disabled={page <= 1}
                      onClick={() => handlePage(page - 1)}
                      className="px-3 py-1 text-sm border rounded disabled:opacity-40 hover:bg-gray-100"
                    >
                      &laquo;
                    </button>
                    <span className="text-sm text-gray-600">Halaman {page} / {maxPage}</span>
                    <button
                      disabled={page >= maxPage}
                      onClick={() => handlePage(page + 1)}
                      className="px-3 py-1 text-sm border rounded disabled:opacity-40 hover:bg-gray-100"
                    >
                      &raquo;
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Detail */}
      <Modal size="xl" active={showModalDetail} toggler={() => setShowModalDetail(true)}>
        <ModalHeader toggler={() => setShowModalDetail(false)}>
          Riwayat Cuti — {selectedKaryawan?.NamaKaryawan}
        </ModalHeader>
        <ModalBody>
          <FilterTahunRiwayat rows={riwayatSemua} value={tahunRiwayat} onChange={setTahunRiwayat} />
          {mutationDetail.isLoading ? (
            <p className="text-center py-4 text-gray-400">Loading...</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left">
                <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                  <tr>
                    <th className="px-3 py-2">ID</th>
                    <th className="px-3 py-2">Tanggal</th>
                    <th className="px-3 py-2 text-center">Saldo Awal</th>
                    <th className="px-3 py-2 text-center">Diambil</th>
                    <th className="px-3 py-2 text-center">Saldo Akhir</th>
                    <th className="px-3 py-2">Keterangan</th>
                    <th className="px-3 py-2">Status</th>
                    <th className="px-3 py-2">Approval</th>
                    <th className="px-3 py-2 text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {riwayatTampil.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="px-3 py-6 text-center text-gray-400">{pesanKosong(tahunRiwayat)}</td>
                    </tr>
                  ) : (
                    riwayatTampil.map((item) => (
                      <tr key={item.TCutiID} className="hover:bg-gray-50">
                        <td className="px-3 py-2 text-gray-500">{item.TCutiID}</td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          {item.TanggalMonitoring}
                          {item.Periode && <div className="text-xs text-gray-400">{item.Periode}</div>}
                        </td>
                        <td className="px-3 py-2 text-center">{item.HakCuti}</td>
                        <td className="px-3 py-2 text-center">{item.JmlCutiDiambil}</td>
                        <td className="px-3 py-2 text-center">
                          <span className={parseInt(item.SaldoAkhirCuti) <= 3 ? "text-red-600 font-semibold" : "text-green-600 font-semibold"}>
                            {item.SaldoAkhirCuti}
                          </span>
                        </td>
                        <td className="px-3 py-2">{item.JenisCutiKet} — {item.KeperluanCuti}</td>
                        <td className="px-3 py-2">
                          <span className={item.StatusKet === "Selesai" ? "text-green-600" : item.StatusKet === "Ditolak" ? "text-red-600" : "text-yellow-600"}>
                            {item.StatusKet}
                          </span>
                        </td>
                        <td className="px-3 py-2 text-xs align-top">
                          <CutiApprovalActors list={item.ApprovalList} />
                        </td>
                        <td className="px-3 py-2 text-center">
                          {item.StatusKet === "Belum Dikirim" && (
                            <button
                              onClick={() => {
                                dispatch(kirimCutiTransaksi({ TCutiID: item.TCutiID })).then((res) => {
                                  let formData = new FormData();
                                  formData.append("Nik", selectedKaryawan.Nik);
                                  mutationDetail.mutate(formData);
                                  // Kirim bisa ditolak server (mis. Bagian karyawan belum
                                  // punya alur approval) — jangan tampilkan "Berhasil".
                                  if (res.meta.requestStatus === "rejected") {
                                    toast.error(res.payload?.message || "Gagal mengirim cuti", {
                                      position: "bottom-right", autoClose: 6000, theme: "light",
                                    });
                                    return;
                                  }
                                  toast.success("Berhasil mengirim cuti", {
                                    position: "bottom-right", autoClose: 3000,
                                    hideProgressBar: false, closeOnClick: true,
                                    pauseOnHover: false, draggable: true, theme: "light",
                                  });
                                });
                              }}
                              className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded whitespace-nowrap"
                            >
                              Kirim
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="blueGray" buttonType="link" onClick={() => setShowModalDetail(false)}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Tambah/Edit */}
      <Modal
        size="lg"
        active={showModalAdd}
        toggler={() => setShowModalAdd(true)}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody className="w-full">
          <form className="w-96" onSubmit={submitHandler}>
            {inputBuilder.map(
              ({ type, name, title, handler, modifiers, size, required }, id) => (
                <HrdInputGenerator
                  key={id}
                  type={type}
                  value={values}
                  name={name}
                  title={title}
                  onChange={handler}
                  touched={touched}
                  buttonTouched={buttonTouched}
                  errors={errors}
                  modifiers={modifiers}
                  size={size}
                  required={required}
                />
              )
            )}
            <div className="w-full px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Jumlah Hari Terpakai
              </label>
              {mutationHari.isLoading ? (
                <span className="text-sm text-gray-400">Loading...</span>
              ) : (
                <input
                  value={jumlahHari}
                  disabled
                  className={
                    buttonDisabled
                      ? "appearance-none block w-full text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full text-green-700 border border-green-700 rounded py-3 px-4 leading-tight outline-none bg-white"
                  }
                  type="text"
                />
              )}
              {saldoTahun && values.Nik && (
                <p className="text-gray-600 text-xs mt-1">
                  Sisa hak cuti {saldoTahun.periode ? `(${saldoTahun.periode})` : `tahun ${saldoTahun.tahun}`}: {saldoTahun.saldo} hari
                </p>
              )}
              {saldoTahun?.peringatan && values.Nik && (
                <p className="text-yellow-700 text-xs mt-1">{saldoTahun.peringatan}</p>
              )}
              {saldoTahun?.blokir && values.Nik && (
                <p className="text-red-500 text-xs italic">{saldoTahun.blokir}</p>
              )}
              {buttonDisabled && !saldoTahun?.blokir && (
                <p className="text-red-500 text-xs italic">Saldo Tidak Cukup</p>
              )}
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>
          <Button
            color={(isValid || (showModalEdit && !isValid)) && !buttonDisabled ? "green" : "blueGray"}
            onClick={() => {
              if (!isValid && changed) setButtonTouched(true);
              let tempIsValid = isValid;
              if (showModalEdit && !isValid) tempIsValid = true;
              if (tempIsValid) {
                if (showModalEdit) {
                  dispatch(updateCutiTransaksi(Object.assign(values)));
                } else {
                  let formData = new FormData();
                  formData.append("Nik", values.Nik);
                  formData.append("JenisCuti", values.JenisCuti);
                  formData.append("KeperluanCuti", values.KeperluanCuti);
                  formData.append("Pengganti", values.Pengganti);
                  formData.append("TanggalMulai", tanggalLokal(values.TanggalMulai));
                  formData.append("TanggalAkhir", tanggalLokal(values.TanggalAkhir));
                  formData.append("Tiket", values.Tiket);
                  mutationInput.mutate(Object.assign(formData), {
                    onSuccess: (data) => {
                      toast.success(data.message, {
                        position: "bottom-right", autoClose: 5000,
                        hideProgressBar: false, closeOnClick: true,
                        pauseOnHover: false, draggable: true, theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      setParam({ start: 0, count: maxPageGlobal, search: "" });
                    },
                    onError: (data) => {
                      toast.error(data?.response?.data?.message || data.message, {
                        position: "bottom-right", autoClose: 5000,
                        hideProgressBar: false, closeOnClick: true,
                        pauseOnHover: false, draggable: true, theme: "light",
                      });
                    },
                  });
                  clearHandler();
                }
              }
            }}
            disabled={buttonDisabled}
            ripple={isValid ? "light" : ""}
          >
            {mutationInput.isLoading ? "Loading..." : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CutiPage;
